import { offlineRetryModalActionTypes } from '@/components/modals/offlineRetryModal/Constants';

import type { Action } from '@/shared/types';

const initialState = {
	open: false,
	actionCall: null,
};

export default function offlineRetryModalReducer(state = initialState, action: Action) {
	const { type, payload } = action;
	const { actionCall } = payload || ({} as any);

	switch (type) {
		case offlineRetryModalActionTypes.OPEN_OFFLINE_RETRY_MODAL:
			return {
				open: true,
				actionCall,
			};

		case offlineRetryModalActionTypes.CLOSE_OFFLINE_RETRY_MODAL:
			return initialState;

		default:
			return state;
	}
}
